/* EuroVan – generic product template (product.json): variant buttons show their own price,
   compare-at price and stock, like the VANPOWER / window templates. Loaded by vpg-price (kind generic). */
(function () {
  'use strict';
  function init() {
    if (document.querySelector('[data-vpk-hero],[data-vpw]')) return;
    var picker = document.querySelector('variant-picker');
    if (!picker || picker.dataset.vpgReady) return;
    var el = picker.querySelector('script[type="application/json"]');
    if (!el) return;
    var data; try { data = JSON.parse(el.textContent); } catch (e) { return; }
    var product = data.product; if (!product || !product.variants || product.variants.length < 2) return;
    var sels = picker.querySelectorAll('.option-selector[data-selector-type="listed"]');
    if (!sels.length) return;
    picker.dataset.vpgReady = '1';
    picker.classList.add('vpk-picker', 'vpg-picker');
    var box = document.querySelector('[data-vpg-price]');
    var oosTxt = (box && box.getAttribute('data-oos')) || '—';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var lang = document.documentElement.lang || 'en';
    function money(c) {
      if ((cur) === 'EUR') { var e = (Math.round(c) / 100).toFixed(2).split('.'); return '€' + e[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (e[1] === '00' ? '' : ',' + e[1]); } /* same format as the theme's prices */
            var n = c / 100, whole = Math.round(n) === n;
      try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(n); }
      catch (e) { return n.toFixed(2) + ' ' + cur; }
    }
    var groups = [];
    sels.forEach(function (sel, si) {
      var list = [];
      sel.querySelectorAll('input.js-option').forEach(function (inp) {
        var label = sel.querySelector('label[for="' + inp.id + '"]'); if (!label) return;
        var pr = label.querySelector('.vpk-pr');
        if (!pr) { pr = document.createElement('span'); pr.className = 'vpk-pr'; label.appendChild(pr); }
        list.push({ input: inp, label: label, pr: pr });
      });
      groups.push({ index: si, list: list });
    });
    function current() {
      return groups.map(function (g) { for (var i = 0; i < g.list.length; i++) if (g.list[i].input.checked) return g.list[i].input.value; return null; });
    }
    function find(vals) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var k = 0; k < vals.length; k++) if (vals[k] !== null && v.options[k] !== vals[k]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function update() {
      var sel = current();
      groups.forEach(function (g) {
        g.list.forEach(function (it) {
          var vals = sel.slice(); vals[g.index] = it.input.value;
          var v = find(vals);
          it.pr.textContent = '';
          it.label.classList.toggle('vpk-oos', !!v && !v.available);
          if (!v) return;
          if (!v.available) { it.pr.textContent = oosTxt; return; }
          var now = document.createElement('span'); now.className = 'vpk-pr__now'; now.textContent = money(v.price); it.pr.appendChild(now);
          if (v.compare_at_price > v.price) { var was = document.createElement('s'); was.className = 'vpk-pr__was'; was.textContent = money(v.compare_at_price); it.pr.appendChild(was); }
        });
      });
    }
    picker.addEventListener('change', function () { setTimeout(update, 0); });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
